import L from "leaflet";
import * as z from "../../../framework";
import { Component, ComponentOptions } from "../../../framework/components/components/component";
import { TemplateComponent } from "../../../framework/components/components/templateComponent";
import Map from "../map/map";
import K_EditableLabelGroupLocation from "../templates/K_EditableLabelGroupLocation";
import popUpView from "./editableLabelGroupLocationPopUp.view";

export interface EditableLabelGroupLocationOptions extends ComponentOptions {
    components?: Component[];
    linkId?: string;
    iconType?: string;
    iconId?: string;
    iconClasses?: string;
    headerLabelBind?: string;
    observableName?: string;
    containerName?: string;
    bsc?: string;
    linkClasses?: string;
}

export class EditableLabelGroupLocation extends TemplateComponent {

    options: EditableLabelGroupLocationOptions;
    content: {
        components: Component[];
    };
    latLongObject: any;
    siteLayer: any;
    map: any;
    marker: any;
    dragged: any;
    highlightEvent: any;

    constructor(options: EditableLabelGroupLocationOptions) {
        super(K_EditableLabelGroupLocation, options);

        this.content = {
            components: options.components || []
        };
    }

    preRender() {
        const options = this.options;

        options.containerClasses = options.containerClasses || "";
        options.linkId = options.linkId || options.id + "_Edit";
        options.iconType = "markerMap";
        options.iconId = options.iconId || options.id + "_MapMarker";
        options.iconClasses = options.iconClasses || "";
        options.headerLabelBind = z.util.buildDataBindSyntax(options.headerLabelBind || "Location", "label");

        options.observableName = options.observableName;
        options.containerName = options.containerName;
    }

    create() {
        var me = this;
        const args = me.options;

        var parent = $("#" + args.id);

        $("#" + args.id + "_Edit").tie("click", function () {
            parent.find(".display-label").hide();
            parent.find(".editable-input-container").show();
            var firstElem = null;
            $.each(parent.find("[data-z-role]"), function (index: any, elem) {
                elem = $(elem);
                var dataRole = elem.data("zRole");

                if (index == 0) {
                    firstElem = elem;
                    if (!elem.data("kendo" + dataRole)) {
                        elem["kendo" + dataRole]({
                            min: -90,
                            max: 90,
                            decimals: 8,
                            step: .1,
                            format: "#.########°"
                        });
                    }
                } else if (!elem.data("kendo" + dataRole)) {
                    elem["kendo" + dataRole]({
                        min: -180,
                        max: 180,
                        decimals: 8,
                        step: .1,
                        format: "#.########°"
                    });
                }
            });

            firstElem && firstElem.data("kendoNumericTextBox").focus();
        });

        $("#" + args.id).parentsUntil("#Location").tie("focusout", "#" + args.id, function () {

            $.wait(300).then(function () {

                if (parent.find(".editable-input:focus").length == 0) {
                    parent.find(".editable-input-container").hide();
                    $.each(parent.find(".display-label"), function (index, label) {
                        var labelValue = $(label).text();
                        if ($.trim(labelValue)) {
                            $(label).show();
                        }
                    });
                    parent.removeClass("editing");
                }
            });
        });

        var temp = z.observable(null);
        if (this.options.zScreen.ScreenContainer) {
            temp.set("ScreenContainer", this.options.zScreen.ScreenContainer);
        } else {
            temp.set("ScreenContainer", this.options.containerName);
            temp.set("ScreenObservable", this.options.observableName);
        }

        $("#" + this.id).find("." + this.options.iconType).on("click", function (options) {
            if (!this.classList.contains("disabled")) {
                var mapPopUp = z.controls.popUp({
                    id: "mapPopUp",
                    title: z.ll("Map"),
                    buttons: [
                        {
                            name: z.ll("Apply"),
                            id: "Save",
                            className: "right",
                            clickEvent: function () {

                                if (!$.isNumeric(temp.Latitude)) {
                                    temp.Latitude = 0;
                                }
                                if (!$.isNumeric(temp.Longitude)) {
                                    temp.Longitude = 0;
                                }

                                var lat1 = parseFloat(temp.Latitude).toFixed(8);
                                var long1 = parseFloat(temp.Longitude).toFixed(8);

                                if (!lat1) {
                                    lat1 = me.latLongObject.Latitude;
                                }
                                if (!long1) {
                                    long1 = me.latLongObject.Longitude;
                                }

                                temp.Latitude = lat1;
                                temp.Longitude = long1;

                                // Apparently we're using the id of the component to determine what property to set on the observable! Yikes!
                                var latProperty = args.components[0].id;
                                var longProperty = args.components[1].id;

                                if (latProperty.indexOf("_") != -1) {
                                    latProperty = latProperty.slice(latProperty.indexOf("_") + 1);
                                }
                                if (longProperty.indexOf("_") != -1) {
                                    longProperty = longProperty.slice(longProperty.indexOf("_") + 1);
                                }

                                if (temp.ScreenObservable) {
                                    z.screens[temp.ScreenContainer][temp.ScreenObservable].set(latProperty, lat1);
                                    z.screens[temp.ScreenContainer][temp.ScreenObservable].set(longProperty, long1);
                                } else {
                                    (z.screens[temp.ScreenContainer] as any).observable.set(latProperty, lat1);
                                    (z.screens[temp.ScreenContainer] as any).observable.set(longProperty, long1);
                                }

                                var locationId = $("#" + args.id);
                                if (locationId.hasClass("editing")) {
                                    locationId.find(".display-label").show();
                                    locationId.find(".editable-input-container").hide();
                                }
                            }
                        },
                        {
                            name: z.ll("Close"),
                            className: "left",
                            clickEvent: function () {
                                var locationId = $("#" + args.id);
                                if (locationId.hasClass("editing")) {
                                    locationId.find(".display-label").show();
                                    locationId.find(".editable-input-container").hide();
                                }
                            }
                        }
                    ],
                    open: () => {
                        setTimeout(() => {
                            me.map.leafletMap.invalidateSize();
                        }, 100);
                    }
                });

                var latId = $("#" + args.id).find(".editable-label-container:nth-child(1)").attr("id");
                var longId = $("#" + args.id).find(".editable-label-container:nth-child(2)").attr("id");
                temp.set("latId", latId);
                temp.set("longId", longId);

                var latitude = $("#" + args.id).find("#" + latId).find(".display-label").text() || "0";
                var longitude = $("#" + args.id).find("#" + longId).find(".display-label").text() || "0";

                var detailsGuts = popUpView();
                detailsGuts.options.zScreen = mapPopUp;
                detailsGuts.render(mapPopUp.guts);
                buildMap(mapPopUp, latitude, longitude);
            }
        });

        var buildMap = function (popUp, latitude, longitude) {

            me.latLongObject = {
                latitude: 0,
                longitude: 0,
                confidence: 0,
                zoom: 5,
            };

            me.map = new Map({
                id: popUp.get("#Map")[0].id,
                markerLayers: [{
                    label: "Sites",
                    type: "site"
                }]
            });

            me.siteLayer = me.map.getLayer("Sites");

            var layerClickEvent = function (e) {
                switch (e.layer.type) {
                    case "Customer":
                    case "Site":
                        var timeLineElem = $("#Appointment_" + e.layer.zData.Id);
                        var timeLineViewWrapper = $("#TimeLineViewWrapper");

                        me.highlightEvent({
                            timeLineElem: timeLineElem,
                            timeLinveViewWrapper: timeLineViewWrapper
                        });
                        break;
                    case "Tech":
                        break;
                }
            };

            me.siteLayer.on("click", layerClickEvent);

            me.marker = me.map.addMarker("Sites", {
                latitude: latitude,
                longitude: longitude,
                className: "markerMap",
                draggable: true
            });

            me.marker.on("dragend", function () {
                me.dragged = true;
                var markerLatLng = me.marker.getLatLng();
                var lng = markerLatLng.lng;

                // 360 is not accurate enough, need to use better meridian/radian calculation of world if user selects worlds to left or right of original
                if (markerLatLng.lng > 180) {
                    lng = markerLatLng.lng - ((parseInt((markerLatLng.lng / 180) as any, 10) + 360));
                } else if (markerLatLng.lng < -180) {
                    lng = markerLatLng.lng - ((parseInt((markerLatLng.lng / 180) as any, 10) - 360));
                }

                temp.set("Latitude", markerLatLng.lat);
                temp.set("Longitude", lng);
                me.dragged = false;
            });

            popUp.get("#UserLatitude").data("kendoNumericTextBox").bind("spin", function () {
                popUp.get("#UserLatitude").blur();
            });

            popUp.get("#UserLongitude").data("kendoNumericTextBox").bind("spin", function () {
                popUp.get("#UserLongitude").blur();
            });

            popUp.get("#UseEnteredCoord").tie("click", function (e) {
                me.marker.setLatLng([temp.Latitude, temp.Longitude]);
                me.map.leafletMap.setView([temp.Latitude, temp.Longitude], temp.Zoom);
                me.dragged = false;
            });

            temp.set("Latitude", latitude);
            temp.set("Longitude", longitude);
            me.map.leafletMap.setView([temp.Latitude, temp.Longitude], me.latLongObject.zoom);

            z.bind({ container: popUp.container, bind: ".bind-label", data: z.LocalizedLanguage });
            z.bind({ container: popUp.container, bind: ".bind-value", data: temp });

        };
    }

}
